import { useEffect, memo } from 'react';
import { createPortal } from 'react-dom';

let dragposition = '';

const Portal = memo(({ children }) => {
  const mount = document.getElementById('mainmenu');
  let el = document.getElementById('notification-content');
  if (!el) {
    el = document.createElement('div');
    el.setAttribute('id', 'notification-content');
  }
  useEffect(() => {
    console.log('mounted', dragposition);
    mount.appendChild(el);
    if (dragposition) {
      $('.notification-left-wrapper').css(dragposition);
    }
    setTimeout(() => {
      $('.notification-left-wrapper').draggable({ 
        containment: 'document',
        cancel: '.kr-data-scale-range',
        drag: (event, ui) => {
          dragposition = ui.position;
        }
      });
    }, 100);
    return () => mount.removeChild(el);
  }, [mount, el]);

  return createPortal(children, el)
});

export default Portal;